<template>
  <div class="mod-mobile-demo"></div>
</template>

<script>
export default {
  name: 'ModMobileDemo'
}
</script>

<style lang="postcss">
.mod-mobile-demo {
  height: 333px;
  background: url(../assets/images/bg-home-2.png) #fff no-repeat center;
}
</style>
